export const DEAL_SCHEDULE_ZOOM_ITEM_WEEK: string = 'week';
export const DEAL_SCHEDULE_ZOOM_ITEM_MONTH: string = 'month';
export const DEAL_SCHEDULE_ZOOM_ITEM_QUARTER: string = 'quarter';
export const DEAL_SCHEDULE_ZOOM_ITEM_YEAR: string = 'year';

export const DEAL_SCHEDULE_ZOOM_ITEM_LIST: DealScheduleZoomItem[] = [
  {
    id: 1,
    name: DEAL_SCHEDULE_ZOOM_ITEM_WEEK,
    title: 'Week',
  },
  {
    id: 2,
    name: DEAL_SCHEDULE_ZOOM_ITEM_MONTH,
    title: 'Month',
  },
  {
    id: 3,
    name: DEAL_SCHEDULE_ZOOM_ITEM_QUARTER,
    title: 'Quarter',
  },
  {
    id: 4,
    name: DEAL_SCHEDULE_ZOOM_ITEM_YEAR,
    title: 'Year',
  },
];
